/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { MDDEResult } from "@sa/rep-mdde";
import { useDictionary, useOLAPTransformer, yearToCropYearFull, OLAPTransformerResult, useParameter, OLAPTransformerOptions } from "../../../shared";
import { dataService, dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import Highcharts, { SeriesOptionsType } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe } from "../../../../charts/pipes";
import { equal } from "../../../../../shared";

const CATEGORIES_AXIS = "commodities.default";
const SERIES_AXIS = "countries.default";

export function useTreemapData(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [business] = [1];
  const [, categories] = useDictionary(dictionaryService, "slides-commodities");
  const [itemsCategoriesDisplay, categoriesDisplay] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
    'slide': 7,
    'business_unit': business
  });
  const [, series] = useDictionary(dictionaryService, "slides-countries");
  const options = useMemo<OLAPTransformerOptions | null>(() => {
    if (!olapResult || !categoriesDisplay || !series) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsNameProxy: new Map([
        [`${CATEGORIES_AXIS}.name`, (id: unknown, lcid: number) => {
          const items = itemsCategoriesDisplay;
          const item = items?.find(x => String(x.getValue('olap_commodity')) === String(id));
          return item?.getValue('name') || { [lcid]: '' };
        }]
      ]),
      attrsDictionaries: new Map([
        [CATEGORIES_AXIS, categories],
        [SERIES_AXIS, series],
      ]) as ReadonlyMap<string, Dictionary>
    } as OLAPTransformerOptions
  }, [olapResult, categoriesDisplay, itemsCategoriesDisplay, series]);
  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${CATEGORIES_AXIS}.name`],
      rows: [`${SERIES_AXIS}.name`],
      cellData: {
        inCell: ["Measures.country_value", "Measures.change", "Measures.world_total_crops", "Measures.world_value", "Measures.share_of_country", "Measures.share_of"],
        attributes: [`${CATEGORIES_AXIS}.name`, `${SERIES_AXIS}.name`, `${CATEGORIES_AXIS}.id`, `${SERIES_AXIS}.id`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
